/*******************************************************************************
 * @ngdoc    object
 * @name     Fundraiser
 * @module   csm.books.services.NewBooksData
 * @constructor
 * @param {object=} info  Fundraiser info read from database.
 * @description
 * Fundraiser information.
 *******************************************************************************/
FundraiserConfig.$inject = ['TypeFactoryProvider'];
/* @ngInject */ export function FundraiserConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'NewBooksData.Fundraiser',
    $type: 'csm.booksdb.data.Fundraiser, CSMBooksDBCS',
    inherits: 'NewBooksData.ClassInfo',
    prototype: {
      clubID: null, // Club ID
      clubName: null, // Club name
      notes: null, // Notes
      startDate: null, // Start date.
      endDate: null, // End date.
      createdOn: null // Creation date.
    },
    constructor: function(NewBooksData, SERVER) {
      return function (data) {
        NewBooksData.ClassInfo.call(
          this,
          Object.assign({}, data, {
            type: SERVER.BooksDBConstants.CT_FUNDRAISER
          })
        );
      };
    }
  });
}
